import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Offerings',
    href: '#offerings'
  }, {
    name: 'Reviews',
    href: '#reviews'
  }, {
    name: 'About Me',
    href: '#about'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-night-900/90 backdrop-blur-md py-4 shadow-lg' : 'bg-transparent py-6'}`} data-id="element-63">
      <div className="absolute inset-0 bg-grain opacity-10 pointer-events-none" data-id="element-64"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-65">
        <div className="flex justify-between items-center" data-id="element-66">
          <a href="#" className="flex flex-col items-start group" data-id="element-67">
            <span className="font-serif text-2xl font-bold text-cream-50 tracking-wider group-hover:text-gold-400 transition-colors duration-300" data-id="element-68">
              Mark V Coaching
            </span>
            <span className="font-sans text-xs text-gold-400 tracking-widest font-medium mt-0.5" data-id="element-69">
              By Mark Vermeulen
            </span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-70">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-cream-50/80 hover:text-gold-400 transition-colors text-sm uppercase tracking-widest font-medium" data-id="element-71">
                {link.name}
              </a>)}
            <Button variant="primary" href="#contact" className="!px-6 !py-2 !text-sm" data-id="element-72">
              Book a Session
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden text-cream-50 hover:text-gold-400 transition-colors" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-73">
            {mobileMenuOpen ? <X size={24} data-id="element-74" /> : <Menu size={24} data-id="element-75" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-76">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-night-900 border-t border-white/10 overflow-hidden" data-id="element-77">
            <div className="px-4 py-6 space-y-4 flex flex-col items-center" data-id="element-78">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-cream-50 hover:text-gold-400 text-lg font-medium py-2" onClick={() => setMobileMenuOpen(false)} data-id="element-79">
                  {link.name}
                </a>)}
              <Button variant="primary" href="#contact" className="w-full max-w-xs mt-4" onClick={() => setMobileMenuOpen(false)} data-id="element-80">
                Book a Session
              </Button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}